"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var FILE_LOADED = exports.FILE_LOADED = "FILE_LOADED";
var FILE_WRITTEN = exports.FILE_WRITTEN = "FILE_WRITTEN";
var FILE_DELETED = exports.FILE_DELETED = "FILE_DELETED";
//# sourceMappingURL=fileConstants.js.map


//////////////////
// WEBPACK FOOTER
// ../wheelhouse-core/dist/file/fileConstants.js
// module id = 99
// module chunks = 0